/**
 * DataWorks custom themes – primary #fad270, dark theme preferred.
 * See: https://backstage.io/docs/conf/user-interface/
 */
import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

const primaryGold = '#fad270';
const primaryGoldDark = '#e5b94a';
const darkNavBg = '#1e1e1e';
const darkSurface = '#252525';

export const lightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: { main: primaryGold },
      secondary: { main: primaryGoldDark },
      navigation: {
        background: darkNavBg,
        indicator: primaryGold,
        color: '#b0b0b0',
        selectedColor: primaryGold,
        navItem: { hoverBackground: 'rgba(250, 210, 112, 0.12)' },
        submenu: { background: '#2a2a2a' },
      },
    },
  }),
  fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif',
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: [primaryGold, primaryGoldDark], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({ colors: [primaryGold, primaryGoldDark], shape: shapes.round }),
    service: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
    }),
    other: genPageTheme({ colors: [primaryGold, primaryGoldDark], shape: shapes.wave }),
    app: genPageTheme({ colors: [primaryGold, primaryGoldDark], shape: shapes.wave }),
    apis: genPageTheme({ colors: [primaryGold, primaryGoldDark], shape: shapes.wave }),
  },
});

export const darkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: { main: primaryGold, dark: primaryGoldDark },
      secondary: { main: primaryGoldDark },
      background: {
        default: '#121212',
        paper: darkSurface,
      },
      navigation: {
        background: darkNavBg,
        indicator: primaryGold,
        color: '#b0b0b0',
        selectedColor: primaryGold,
        navItem: { hoverBackground: 'rgba(250, 210, 112, 0.12)' },
        submenu: { background: '#2a2a2a' },
      },
      banner: {
        info: '#34548a',
        error: '#8c4351',
        text: '#e0e0e0',
        link: primaryGold,
        closeButtonColor: '#b0b0b0',
        warning: '#8f5e15',
      },
    },
  }),
  fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif',
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
      options: { fontColor: '#121212' },
    }),
    documentation: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave2,
      options: { fontColor: '#121212' },
    }),
    tool: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.round,
      options: { fontColor: '#121212' },
    }),
    service: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
      options: { fontColor: '#121212' },
    }),
    website: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
      options: { fontColor: '#121212' },
    }),
    library: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
      options: { fontColor: '#121212' },
    }),
    other: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
      options: { fontColor: '#121212' },
    }),
    app: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
      options: { fontColor: '#121212' },
    }),
    apis: genPageTheme({
      colors: [primaryGold, primaryGoldDark],
      shape: shapes.wave,
      options: { fontColor: '#121212' },
    }),
  },
});
